import { ErrorHandler, ModuleWithProviders, NgModule, InjectionToken } from '@angular/core';
import { IErrorHandlerOptions } from './error-handler-interfaces.service';
import { ErrorHandlerService } from './error-handler.service';

export const DISPLAY_ERROR_TOKEN = new InjectionToken<Function>('DisplayErrorToken');
export const LOG_ERROR_TOKEN = new InjectionToken<Function>('LogErrorToken');
export const REDIRECT_ADDRESS_TOKEN = new InjectionToken<string>('RedirectAddressToken');
export const MESSAGE_TOKEN = new InjectionToken<string | undefined>('MessageToken');
export const STATIC_ERROR_ID_TOKEN = new InjectionToken<string | undefined>('StaticErrorIdToken');

/**
 * An intermediary injectable used to provide the raw config argument's value to the factory function
 * without causing AOT failures. NOTE: This value has to be exported otherwise the AoT compiler won't see it.
 */
export const ERROR_HANDLER_USER_OPTIONS = new InjectionToken<IErrorHandlerOptions>('ERROR_HANDLER_USER_OPTIONS');

/**
 * A simple factory that will get it's options value from the above token and create an options object.
 * "In order to play nicely with the AoT compiler, you have to extract the factory function declaration out
 * as a top-level exported value on the JavaScript module."
 * @see https://www.bennadel.com/blog/3565-providing-module-configuration-using-forroot-and-ahead-of-time-compiling-in-angular-7-2-0.htm
 */
export function ErrorHandlerModuleOptionsFactory (options: IErrorHandlerOptions = {}): IErrorHandlerOptions {
    return options;
}

@NgModule({
    imports: [],
    providers: [ ErrorHandlerService ]
})
export class ErrorHandlerModule {
    /** Provide a configuration object for the Error Handler including required services that will be provided via `useExisting`. */
    static forRoot (config?: IErrorHandlerOptions): ModuleWithProviders<ErrorHandlerModule> {
        return {
            ngModule: ErrorHandlerModule,
            providers: [
                { provide: ErrorHandler, useClass: ErrorHandlerService },
                { provide: 'ERROR_HANDLER_SERVICE', useExisting: ErrorHandlerService },
                { provide: ERROR_HANDLER_USER_OPTIONS, useValue: config },
                {
                    deps: [ ERROR_HANDLER_USER_OPTIONS ],
                    provide: 'ERROR_HANDLER_OPTIONS',
                    useFactory: ErrorHandlerModuleOptionsFactory
                },
                { provide: DISPLAY_ERROR_TOKEN, useValue: () => {} }, // Replace with actual function
                { provide: LOG_ERROR_TOKEN, useValue: () => {} }, // Replace with actual function
                { provide: REDIRECT_ADDRESS_TOKEN, useValue: 'http://example.com' },
                { provide: MESSAGE_TOKEN, useValue: 'Default Message' },
                { provide: STATIC_ERROR_ID_TOKEN, useValue: 'STATIC_ID' }
            ]
        };
    }
}
